module.exports = "/images/estoc4.png?115692cb6b5d3684a4368ed05388ebfc";